const GET_LINK_DRIVER = "/driver-linked-member/get-linked-drivers";

const ADD_LINKED_DRIVER = "/driver-linked-member/add-link-driver";

const ACCEPT_LINKED_DRIVER_REQUEST =
  "/driver-linked-member/accept-driver-link-request";

const DELETE_LINKED_DRIVER = "/driver-linked-member/delete-linked-driver";

const SEND_MESSAGE_TO_LINKED_DRIVER = "/driver-linked-member/send-message";

export {
  GET_LINK_DRIVER,
  DELETE_LINKED_DRIVER,
  ADD_LINKED_DRIVER,
  ACCEPT_LINKED_DRIVER_REQUEST,
  SEND_MESSAGE_TO_LINKED_DRIVER,
};
